import api from '../utils/api';

export const sendContact = async (data :any, idioma: string) => {
    try {
        const response = await api.post('/api/emails/send', {
            Tipo: 'CONTACTO',
            Nombre: data.Nombre,
            CorreoElectronico: data.CorreoElectronico,
            Mensaje: data.Mensaje,
            Idioma: idioma
        });

        return response.data;
    } catch (error) {
        return { Result: false };
    }
};

export interface ContactFormData {
    name: string;
    email: string;
    subject: string;
    message: string;
}

